import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import SearchArea from "./area/search";
import SumPointArea from "./area/sum_area";

function PointListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const [infoArr, setInfoArr] = useState([]);
  let default_count_info = { "tot": 0, a_amount: 0, row_view_money_in: 0, row_view_money_out: 0 };
  const [countInfo, setCountInfo] = useState({ ...default_count_info });
  const [point_tot_info, set_point_tot_info] = useState<any>({
    in_money: 0, out_money: 0, in_debt: 0, out_debt: 0, tot: 0
  });

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_mcomp_seq": "",
    "s_year": DateFunc.get_date_format(new Date(), "Y"),
    's_date_type': 'a_date',
    's_start_date': DateFunc.get_date_format(new Date(), "Y-m-01"),
    's_end_date': DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_money_sum: "1",
  });

  useEffect(() => {
    list({});
    get_comp_info_of_point_by_ajax();
  }, [user]);

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(change_list_opt);
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    change_list_opt.s_mcomp_seq = user.comp_seq;

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/point/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo({
            ...default_count_info,
            ...response.data["data"]["count_info"]
          });
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const get_comp_info_of_point_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let form_json_data = {
      s_seq: user.comp_seq,
      is_addon_point_tot: "1",
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            if (response.data["data"]["info_arr"][0]["point_tot_info"]) {
              set_point_tot_info(response.data["data"]["info_arr"][0]["point_tot_info"]);
            }
          }
        } else {

        }
      });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    var render_str = params.value;
    if (params.key == "row_view_in_point") {
      if (params.rowData.a_inout == "in" && params.rowData.a_type == "money") {
        render_str = strFunc.comma(params.rowData.a_amount);
      }
    } else if (params.key == "row_view_out_point" && params.rowData.a_type == "money") {
      if (params.rowData.a_inout == "out") {
        render_str = strFunc.comma(params.rowData.a_amount);
      }
    }
    return render_str;
  };

  return (
    <div>
      <div>
        <SearchArea
          listOpt={listOpt}
          list={list}
        ></SearchArea>
      </div>
      <div>
        <SumPointArea
          point_tot_info={point_tot_info}
          countInfo={countInfo}
          listOpt={listOpt}
        ></SumPointArea>
      </div>
      <div className="mt-1">
        <ListComponent
          ref={ListComponentRef}
          xColumnArr={{ ...xColumnArr }}
          gridOpt={{
            fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
            is_add_idx_num: false,
            is_add_checkbox: true,
            td_align: "center",
            height: "auto",
            is_fix_width: true,
            rowMultiSelectWithClick: false,
            onGridReady: () => {

            },

            is_all_select_row_key: true,
            rowOnClick: rowOnClick,
            customCellRenderer: customCellRenderer,
            class_name_json: {
              table_div: "basic_list_div",
              td_div: "row-col-div",
              input_check: "chk_row",
              row_input: "row-input",
              data_row_tr: "data_row_tr",
              active_row: "active",
              empty_con_div: "list_empty_content_div",
            },
          }}
        ></ListComponent>
      </div>
      <div>
        <Paging
          now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
      </div>
    </div>
  );
};
export default PointListArea;